/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import Slider from 'react-slick';
import {
    object, string, shape, bool, func,
} from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import LazyLoad from 'react-lazyload';
import withStyles from '@material-ui/core/styles/withStyles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Fade from '@material-ui/core/Fade';
import { SideBySideMagnifier } from 'react-image-magnifiers';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import isProductListingAd from '../../../../helpers/isProductListingAd';
import GraphqlSmartGiftUI from './GraphqlSmartGiftUI';
import { shouldRenderSnipe, snipePath } from './common/commonProductPageHelper';
import GraphqlClubPDPImage from './GraphqlClubPDPImage/GraphqlClubPDPImage';
import { clubComponentType } from './common/types';
import SnipeRender from './common/SnipeRender';
import ProductPartNumber from '../GraphqlPlantsProductPageBuilder/Partials/ProductPartNumber';
import Favorite from '../../WishlistPage/Favorite';

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        background: theme?.palette?.white,
        [theme?.breakpoints?.down('md')]: {
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
        cursor: 'pointer',
    },
    altImageContainer: {
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        maxWidth: '110px',
        [theme?.breakpoints?.down('md')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'flex',
            maxWidth: '100%',
        },
    },
    altImageButton: {
        display: 'block',
        padding: 0,
        margin: '0 10px 10px 0',
        position: 'relative',
        width: '100%',
        height: 'auto',
        border: 'none',
        outline: 'none', // TODO: Need to add outline for accessibility
        cursor: 'pointer',
        [theme?.breakpoints?.down('md')]: {
            maxWidth: '110px',
        },
        // [theme?.breakpoints?.down('sm')]: {
        //     maxWidth: '95%',
        // },
    },
    altImage: {
        width: '100%',
        height: 'auto',
    },
    altImageMobile: {
        margin: '0 auto',
    },
    productImageWrapper: {
        flex: '1 1 auto',
        order: '2',
        maxWidth: '600px',
        height: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            order: '1',
        },
    },
    productImage: {
        width: '100%',
        height: 'auto',
        [theme?.breakpoints?.down('md')]: {
            height: 'auto',
        },
    },
    satisfactionImage: {
        position: 'absolute',
        width: '124px',
        height: 'auto',
        bottom: '45px',
        right: '15px',
    },
    snipe: {
        position: 'absolute',
        bottom: '5px',
        right: '0',
        left: '0',
        top: '0',
        width: '100%',
    },

    productImageWrapperClub: {
        display: 'inline-block',
        margin: '0',
        minWidth: '200px',
        maxWidth: '600px',
        height: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            marginLeft: '20px',
        },
        [theme?.breakpoints?.down('sm')]: {
            marginLeft: 0,
            maxWidth: '100%',
        },
    },

    monthSnipe: {
        position: 'absolute',
        right: 0,
        left: 0,
        bottom: 0,
        padding: 5,
        backgroundColor: 'rgba(47,47,47, .9)',
        boxSizing: 'border-box',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        textAlign: 'center',
    },
    upsellSelected: {
        '& span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
    },
    upsellImageBox: {
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        maxWidth: '110px',
        [theme.breakpoints.down('md')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'flex',
            maxWidth: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'inline-block',
            maxWidth: '100%',
        },
        '&:hover span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
        '&:last-child': {
            margin: 0,
        },
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        '& .slick-list': {
            display: 'none',
        },
        [theme.breakpoints.down('md')]: {
            width: '92%',
            margin: '0 auto',
        },
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            display: 'block',
            margin: '0 auto',
            '& .slick-slide': {
                float: 'left',
                whiteSpace: 'nowrap',
            },
            '& .slick-list': {
                display: 'block',
            },

        },
    },
    imageContainer: {
        position: 'relative',
        cursor: 'pointer',
    },
    partNumberStyle: {
        textAlign: 'center',
        margin: 0,
    },
    slickVertical: {
        minWidth: '124px !important',
        [theme.breakpoints.down(1264)]: {
            top: '4%',
        },
        [theme.breakpoints.up(1264)]: {
            top: '3%',
        },
        '& .slick-prev': {
            top: '-27px',
            left: '33%',
            opacity: 0.9,
            zIndex: 1,
        },
        '& .slick-next': {
            right: '43%',
            opacity: 0.9,
            bottom: '-3%',
            top: 'unset',
        },
        '& .slick-prev, .slick-next': {
            width: '30px',
            border: 'none',
            cursor: 'pointer',
            height: '25px',
            outline: 0,
            position: 'absolute',
            fontSize: 0,
            transform: 'rotate(90deg)',
            lineHeight: 0,
            '& svg': {
                fill: 'black',
            },
        },
        '& .slick-list': {
            overflow: 'hidden',
            padding: 'unset !important',
        },
        '& .slick-track': {
            opacity: 1,
            height: '419px',
            width: 'unset !important',
            minWidth: '110px !important',
        },
        '& .slick-slide': {
            cursor: 'pointer',
            paddingLeft: 'unset !important',
            paddingRight: '14px !important',
            border: 'unset !important',
            '& button': {
                height: '110px !important',
                minWidth: '110px !important',
                marginBottom: '14px !important',
            },
        },
        '& .unset-top': {
            top: 'unset !important',
        },
        '& .slick-arrow': {
            cursor: 'pointer',
            '&:before': {
                content: '""',
            },
        },
    },
});

const NextArrow = (props) => {
    const { onClick, className } = props;
    return (
        <button className={className} type="button" aria-label="Next Arrow" onClick={onClick}>
            <ChevronRightIcon className="material-icons text-icon" />
        </button>
    );
};
NextArrow.propTypes = {
    onClick: func,
    className: string,
};
NextArrow.defaultProps = {
    onClick: () => {},
    className: '',
};
const PrevArrow = (props) => {
    const { onClick, className } = props;
    return (
        <button className={className} type="button" aria-label="Prev Arrow" onClick={onClick}>
            <ChevronLeftIcon className="material-icons text-icon" />
        </button>
    );
};
PrevArrow.propTypes = {
    onClick: func,
    className: string,
};
PrevArrow.defaultProps = {
    onClick: () => {},
    className: '',
};
class GraphqlProductImageUI extends Component {
    constructor(props) {
        super(props);
        const {
            data: {
                name,
                image,
            },
            selectedSku,
        } = this.props;
        const imageName = selectedSku?.image?.name || '';
        const imagePath = selectedSku?.image?.path || '';
        const defaultImagePath = this.buildImgPath(imagePath, imageName);
        this.state = {
            path: imagePath,
            mainImage: {
                path: imageName,
                fullPath: defaultImagePath,
                imgName: name,
            },
            heroImage: defaultImagePath,
            altImages: image?.additionalImages ? image?.additionalImages : '',
            modalOpen: false,
            selectedComponentMonth: 0,

        };
        this.cdnLink = imagePath || 'https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/catalog/';
    }

    componentDidUpdate(prevProps) {
        const { selectedSku } = this.props;
        if (prevProps.selectedSku !== selectedSku && selectedSku.image) {
            this.setProductImage(selectedSku.image.name);
        }
    }

    buildImgPath = (path, name) => {
        // Convert the image name to lowerCase for particular product
        const { history } = (this.props);
        const getProductUrl = history?.location?.pathname?.includes('treasured-memories-174292');
        const imageName = getProductUrl ? name?.toLowerCase() : name?.replace('L', 'l');
        return `${path + imageName}x.jpg`;
    };

    // If selected SKU image is 404 render parent image
    onImageError = (e) => {
        const { data, presentation_family } = this.props;
        if (data?.image?.path && presentation_family === 'food') {
            const { image } = data;
            e.target.src = this.buildImgPath(image.path, image.name);
        }
        return null;
    }

    getSlides = (items) => {
        const slides = [];
        const { classes } = this.props;
        const { selectedComponentMonth } = this.state;
        (items || []).forEach((imgName, index) => {
            slides.push(
                (
                    <div
                        key={`btnImg-${imgName.month}`}
                        className={`${classes.upsellImageBox} ${(items[selectedComponentMonth]?.month === imgName.month) ? classes.upsellSelected : ''}`}
                    >
                        <button
                            data-testid={`component-${index}`}
                            onClick={() => { this.setState({ modalOpen: true, selectedComponentMonth: index }); }}
                            type="button"
                            className={classes.altImageButton}
                        >
                            {/* <img src={`${this.cdnLink}${imgName.image?.name?.replace('L', 'l')}x.jpg`} alt={imgName.name} className={classes.altImage} /> */}
                            <img src={this.buildImgPath(this.cdnLink, imgName.image?.name)} alt={imgName.name} className={classes.altImage} />
                            <span className={classes.monthSnipe}>{imgName.month?.substr(0, 3)}</span>
                        </button>
                    </div>
                ),
            );
        });
        return slides;
    }

    handleState = (obj) => {
        this.setState(obj);
    }

    setProductImage = (src) => {
        const { selectedSku } = this.props;
        const { path } = this.state;
        const imageName = selectedSku?.image?.name || '';
        const imagePath = selectedSku?.image?.path || '';
        const defaultImagePath = imagePath && imageName ? this.buildImgPath(imagePath, imageName) : '';
        this.setState({
            heroImage: this.buildImgPath(path, src),
            mainImage: {
                path: imageName,
                fullPath: defaultImagePath,
                imgName: selectedSku.name,
            },
        });
    };

    renderZoom = () => {
        const { location, featureFlags } = this.props;
        const isPdpImageZoomEnabled = featureFlags?.['is-pdp-product-zoom-enabled'];
        const isPlaImageZoomEnabled = featureFlags?.['is-pla-product-zoom-enabled'];
        const isPla = isProductListingAd(location.search);
        if (isPla && isPlaImageZoomEnabled) return true;
        if (!isPla && isPdpImageZoomEnabled) return true;
        return false;
    }

    navigate = (type = 'next') => {
        const { selectedComponentMonth } = this.state;
        const { clubComponents } = this.props;
        const slidesLength = clubComponents?.length;
        if (type === 'next') {
            if ((slidesLength - 1) === selectedComponentMonth) {
                this.setState({ selectedComponentMonth: 0 });
            } else {
                this.setState({ selectedComponentMonth: (selectedComponentMonth + 1) });
            }
        } else if (type === 'prev') {
            if (selectedComponentMonth === 0) {
                this.setState({ selectedComponentMonth: (slidesLength - 1) });
            } else {
                this.setState({ selectedComponentMonth: (selectedComponentMonth - 1) });
            }
        }
    }

    getClubLengthDescription = () => {
        const { selectedSku } = this.props;
        const clubLength = selectedSku?.clubLength || 0;
        if (selectedSku?.date && selectedSku?.endDate) {
            return (
                <>
                    {`${clubLength} Months - ${selectedSku.date.month} ${selectedSku.date.year} - ${selectedSku.endDate.month} ${selectedSku.endDate.year}`}
                </>
            );
        }
        return null;
    }

    render() {
        const {
            featureFlags,
            classes,
            data,
            selectedSku,
            presentation_family,
            smartGiftLetThemKnowSection,
            isSmartGiftEnabled,
            brand,
            isClubProduct,
            clubComponents,
            renderSnipe,
            renderHeroImageFlag,
        } = this.props;
        const {
            mainImage,
            altImages,
            path,
            heroImage,
        } = this.state;
        // Use heroImage state to update pdp images when skus are changed
        // To use only the main image and not update by sku, use presentation logic
        // to grab image source from data.image
        const personalizationFlag = featureFlags?.['is-personalization-enabled'] ?? false;
        const showSatisfactionIcon = featureFlags?.['is-satisfaction-icon-enabled'] ?? false;
        const renderHeroImage = () => {
            const imageSource = heroImage;
            let imageTag = (
                <img src={imageSource} alt={data?.name} className={classes.productImage} onError={this.onImageError} />
            );
            if (brand.code === 'PLA' && showSatisfactionIcon) {
                imageTag = (
                    <div>
                        <img src={imageSource} alt={data?.name} className={classes.productImage} onError={this.onImageError} />
                        <img src="/static/images/daysSatisfaction.svg" alt="30 days satisfaction" className={classes.satisfactionImage} />
                    </div>
                );
            }
            return imageTag;
        };
        const setLayout = () => (
            (renderHeroImageFlag)
                ? (
                    renderHeroImage()
                ) : (
                    <>
                        {this.renderZoom()
                            ? (
                                <SideBySideMagnifier
                                    className={classes.productImage}
                                    imageSrc={heroImage}
                                    imageAlt={data?.name}
                                    largeImageSrc={heroImage}
                                />
                            ) : (
                                renderHeroImage()
                            )}
                        {renderSnipe && shouldRenderSnipe(data?.image?.snipe, personalizationFlag) ? ( // if snipe data exsist display snipe img
                            <LazyLoad>
                                <Fade in timeout={700}>
                                    <SnipeRender
                                        altText={data?.image?.altText}
                                        styleProp={classes.snipe}
                                        src={`${data?.image?.snipeImagePath}${data?.image?.snipe}_z.gif`}
                                        fallbackSrc={`${snipePath(data.image.path)}${data?.image?.snipe}_z.gif`}
                                    />
                                </Fade>
                            </LazyLoad>
                        ) : null}
                        {presentation_family === 'flower' && isSmartGiftEnabled
                            && (
                                <GraphqlSmartGiftUI
                                    giftData={smartGiftLetThemKnowSection}
                                    partNumber={data.partNumber}
                                    productName={data.name}
                                    brand={brand}
                                    sku={data?.productSkus?.[0]?.id}
                                    price={data?.productSkus?.[0]?.prices?.[0]?.value}
                                    image={heroImage}
                                />
                            )}
                    </>
                )
        );
        if (!renderHeroImageFlag && isClubProduct) {
            const { modalOpen, selectedComponentMonth } = this.state;
            return (
                <div
                    data-testid="rendered-club-image"
                >
                    <GraphqlClubPDPImage
                        modalOpen={modalOpen}
                        handleState={this.handleState}
                        selectedComponentMonth={selectedComponentMonth}
                        cdnLink={this.cdnLink}
                        clubComponents={clubComponents}
                        product={data}
                        navigate={this.navigate}
                        getSlides={this.getSlides}
                        renderZoom={this.renderZoom}
                        shouldRenderSnipe={shouldRenderSnipe}
                        getClubLengthDescription={this.getClubLengthDescription}
                        selectedSku={selectedSku}
                        heroImage={heroImage}
                        personalizationFlag={personalizationFlag}
                    />
                </div>
            );
        }
        const showMinimumAltImages = window.innerWidth < 1264;
        const isVerticalSliderEnabled = (showMinimumAltImages && altImages.length + 1 > 3) || (!showMinimumAltImages && altImages.length + 1 > 4);
        const sliderSettigs = {
            currentSlide: 0,
            slidesToShow: showMinimumAltImages ? 3 : 4,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            nextArrow: <NextArrow className="unset-top" />,
            prevArrow: <PrevArrow />,
            infinite: false,
        };
        return (
            <div className={classes.root}>
                <div className={classes.productImageWrapper}>
                    {setLayout()}
                    {brand.code === 'PLA' && <ProductPartNumber classes={classes.partNumberStyle} selectedSku={selectedSku} />}
                    {brand.code === 'PLA' && <Favorite partNumber={data?.partNumber} />}
                </div>
                {(altImages && !renderHeroImageFlag) && (
                    <div className={classes.altImageContainer}>
                        {isVerticalSliderEnabled ? (
                            <Slider {...sliderSettigs} className={classes.slickVertical}> {/* eslint-disable-line */}
                                <button type="button" className={classes.altImageButton} onClick={() => { this.setProductImage(selectedSku?.image?.name); }}>
                                    <img src={this.buildImgPath(selectedSku?.image?.path, selectedSku?.image?.name)} alt={mainImage?.imgName} className={classes.altImage} />
                                </button>
                                {altImages.map((imgName) => (
                                    <button key={`btnImg${imgName}`} type="button" className={classes.altImageButton} onClick={() => { this.setProductImage(imgName); }}>
                                        <img src={this.buildImgPath(path, imgName)} alt={mainImage?.imgName} className={classes.altImage} />
                                    </button>
                                ))}
                            </Slider>
                        ) : (
                            <>
                                <button type="button" className={classes.altImageButton} onClick={() => { this.setProductImage(selectedSku?.image?.name); }}>
                                    <img src={this.buildImgPath(selectedSku?.image?.path, selectedSku?.image?.name)} alt={mainImage?.imgName} className={classes.altImage} />
                                </button>
                                {altImages.map((imgName) => (
                                    <button key={`btnImg${imgName}`} type="button" className={classes.altImageButton} onClick={() => { this.setProductImage(imgName); }}>
                                        <img src={this.buildImgPath(path, imgName)} alt={mainImage?.imgName} className={classes.altImage} />
                                    </button>
                                ))}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

GraphqlProductImageUI.propTypes = {
    classes: object.isRequired,
    data: object.isRequired,
    featureFlags: object.isRequired,
    location: object.isRequired,
    presentation_family: string.isRequired,
    selectedSku: object.isRequired,
    smartGiftLetThemKnowSection: shape({
        button_copy: string,
        button_color: string,
        copy: string,
    }),
    brand: shape({
        domain: string,
    }),
    isSmartGiftEnabled: bool,
    isClubProduct: bool,
    clubComponents: clubComponentType,
    renderSnipe: bool,
    renderHeroImageFlag: bool,
    history: shape({
        location: shape({
            pathname: string,
        }),
    }),
};

GraphqlProductImageUI.defaultProps = {
    isClubProduct: false,
    clubComponents: [],
    brand: {},
    smartGiftLetThemKnowSection: {},
    isSmartGiftEnabled: false,
    renderSnipe: true,
    renderHeroImageFlag: false,
    history: {},
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(GraphqlProductImageUI)));
